"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runOauth2Flow = runOauth2Flow;
exports.runRAMLResolver = runRAMLResolver;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var oAuth2Authenticate = _interopRequireWildcard(require("@mulesoft/raml-client/lib/authentication/oauth2"));
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function runRAMLResolver(_x, _x2) {
  return _runRAMLResolver.apply(this, arguments);
}
function _runRAMLResolver() {
  _runRAMLResolver = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(ramlResolver, params) {
    var response, _t;
    return _regenerator.default.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return ramlResolver(params);
        case 1:
          response = _context.sent;
          return _context.abrupt("return", {
            result: (0, _utils.getClonableObject)(response)
          });
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          return _context.abrupt("return", {
            error: (0, _utils.getClonableError)(_t)
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _runRAMLResolver.apply(this, arguments);
}
function runOauth2Flow(_x3) {
  return _runOauth2Flow.apply(this, arguments);
}
function _runOauth2Flow() {
  _runOauth2Flow = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(_ref) {
    var grantType, options, response, _t2;
    return _regenerator.default.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          grantType = _ref.grantType, options = _ref.options;
          _context2.prev = 1;
          _context2.next = 2;
          return oAuth2Authenticate[grantType](options);
        case 2:
          response = _context2.sent;
          return _context2.abrupt("return", {
            result: (0, _utils.getClonableObject)(response)
          });
        case 3:
          _context2.prev = 3;
          _t2 = _context2["catch"](1);
          return _context2.abrupt("return", {
            error: (0, _utils.getClonableError)(_t2)
          });
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return _runOauth2Flow.apply(this, arguments);
}
//# sourceMappingURL=ramlClient.js.map